import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';

import store from '@/store';

import calls from '@/router/routes/calls';
import socialVisits from '@/router/routes/socialVisits';
import visitors from '@/router/routes/visitors';
import kiosk from '@/router/routes/kiosk';
import bookings from '@/router/routes/bookings';
import wings from '@/router/routes/wings';
import purplePhone from '@/router/routes/purplePhone';
import additionalVisitors from '@/router/routes/additionalVisitors';
import socialBookingSlots from '@/router/routes/socialBookingSlots';
import visitLocations from '@/router/routes/visitLocations';
import prisonerVerification from '@/router/routes/prisonerVerification';
import inCellVisits from '@/router/routes/inCellVisits';

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...calls,
    ...socialVisits,
    ...visitors,
    ...additionalVisitors,
    ...kiosk,
    ...bookings,
    ...wings,
    ...purplePhone,
    ...socialBookingSlots,
    ...visitLocations,
    ...prisonerVerification,
    ...inCellVisits,
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/views/Dashboard.vue'),
      meta: {
        protected: true,
        pageTitle: 'Dashboard',
        breadcrumb: [
          {
            text: 'Dashboard',
            active: true,
          },
        ],
      },
    },
    {
      path: '/how-to',
      name: 'how-to',
      component: () => import('@/views/howTo/HowTo'),
      meta: {
        protected: true,
        pageTitle: 'How To',
        breadcrumb: [
          {
            text: 'How To',
            active: true,
          },
        ],
      },
    },
    {
      path: '/bans',
      name: 'bans',
      component: () => import('@/views/bans/BanSearch'),
      meta: {
        protected: true,
        pageTitle: 'Bans',
        breadcrumb: [
          {
            text: 'Bans',
            active: true,
          },
        ],
      },
    },
    {
      path: '/social-bans',
      name: 'social-bans',
      component: () => import('@/views/socialBans/SocialBanSearch'),
      meta: {
        protected: true,
        pageTitle: 'Bans',
        breadcrumb: [
          {
            text: 'Bans',
            active: true,
          },
        ],
      },
    },
    {
      path: '/statistics',
      name: 'statistics',
      component: () => import('@/views/stats/Stats.vue'),
      meta: {
        protected: true,
        pageTitle: 'Statistics',
        breadcrumb: [
          {
            text: 'statistics',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('userTokenPortal');
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
  const loggedIn = !!token;
  // Authed routes that do not allow unauthed users
  if (!loggedIn && to.meta.protected) {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    });
  }
  // UnAuthed routes that do not allow authed users
  if (loggedIn && to.meta.redirectAuthed) {
    next({
      path: '/dashboard',
    });
  }

  // Route permissions
  const requiresPermissions = to.meta.requiresPermission;
  if (requiresPermissions) {
    // Fetch prison data if not already available
    if (!store.state.prison) {
      await store.dispatch('prison/getPrison');
    }

    // Check if user has required permissions
    const userPermissions = store.state.permissions;
    const hasPermissions = Array.isArray(requiresPermissions)
      ? requiresPermissions.every(permission => userPermissions[permission])
      : userPermissions[requiresPermissions];

    if (!hasPermissions) {
      next('/error-404');
      return;
    }
  }

  next();
});

export default router
